import React from 'react';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { connect } from 'react-redux';

// 3rd Party
import Slider from 'react-slick';
import ExecutionEnvironment from 'exenv';
import Collapse from 'react-collapse';

const mapStateToProps = state => ({ isMobile: state.isMobile });

class People extends React.Component {
  constructor(props) {
    super(props);

    this.handleHoverVideo = this.handleHoverVideo.bind(this);

    this.state = {
      sliderSettings: {
        adaptiveHeight: false,
        arrows: true,
        dots: false,
        infinite: true,
        nextArrow: React.createElement('div', null, 'next'),
        prevArrow: React.createElement('div', null, 'prev'),
        responsive: [
          {
            breakpoint: 640,
            settings: {
              centerMode: true,
              centerPadding: 0,
              initialSlide: 1,
              slidesToShow: 2
            }
          },
          {
            breakpoint: 888,
            settings: { slidesToShow: 3 }
          }
        ],
        slidesToScroll: 1,
        slidesToShow: 4,
        speed: 500
      }
    };
  }

  handleHoverVideo(event) {
    const hoveredVideo = event.target,
      hoveredVideoLength = hoveredVideo.duration,
      hoveredVideoWidth = hoveredVideo.clientWidth,
      relativeMousePosition = event.pageX - hoveredVideo.getBoundingClientRect().left,
      relativeMousePositionPercentage = parseInt((relativeMousePosition / hoveredVideoWidth) * 100, 10);

    hoveredVideo.currentTime = (hoveredVideoLength * relativeMousePositionPercentage) / 100;
  }

  render() {
    return (
      <section className="people">
        <Router>
          <div>
            <Slider {...this.state.sliderSettings}>
              {this.props.content.people.map((item, index) =>
                <article key={index} className="employee">
                  <Link to={`/${item.name.replace(/\s/g, '-').toLowerCase()}`}>
                    <div className="video">
                      {!this.props.isMobile &&
                        <video>
                          <source src={`/public/content/assets/${item.teaser_video}`} type="video/mp4"/>
                          Your browser does not support HTML5 video.
                        </video>
                      }
                      <img src={`${require(`../../../public/content/assets/${item.mobile_teaser_image}`)}`} />
                      <Link to={`/${item.name.replace(/\s/g, '-').toLowerCase()}`} className="read-more"/>
                    </div>
                    <h2>{item.name.substr(0, item.name.indexOf(' '))}</h2>
                    <div className="position">{item.position}</div>
                  </Link>
                </article>
              )}
            </Slider>
            {this.props.content.people.map((item, index) =>
              <Route key={index} path={`/${item.name.replace(/\s/g, '-').toLowerCase()}`} children={({ match }) => (
                <Collapse keepCollapsedContent={true} isOpened={match} className="people-full">
                  <Link to="/" className="read-more">
                    <svg id="Ebene_1" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 100 100">
                      <g>
                        <path fill="#8e8e8e" d="M50,5A45,45,0,1,0,95,50,45,45,0,0,0,50,5ZM77,54.75H54.75V77a4.76,4.76,0,1,1-9.5,0V54.75H23a4.76,4.76,0,1,1,0-9.5H45.25V23a4.76,4.76,0,1,1,9.5,0V45.25H77a4.76,4.76,0,1,1,0,9.5Z"/>
                      </g>
                    </svg>
                  </Link>
                  <div className="left">
                    <div className="video">
                      {!this.props.isMobile &&
                        <video autoPlay loop>
                          <source src={`/public/content/assets/${item.full_video}`} type="video/mp4" />
                          Your browser does not support HTML5 video.
                        </video>
                      }
                      <img className="mobile-image" src={`${require(`../../../public/content/assets/${item.mobile_image}`)}`} />
                    </div>
                  </div>
                  <div className="right">
                    <h2>{item.name}</h2>
                    <div className="position">{item.position}</div>
                    <div className="description">
                      <p dangerouslySetInnerHTML={{ __html: item.text }} />
                    </div>
                  </div>
                </Collapse>
              )} />
            )}
          </div>
        </Router>
      </section>
    );
  }

  componentDidMount() {
    if (ExecutionEnvironment.canUseDOM) {
      const peopleVideos = document.querySelectorAll('section.people article.employee video');

      for (const peopleVideo of peopleVideos) {
        peopleVideo.addEventListener('mousemove', this.handleHoverVideo);
      }
    }

    // If Page gets called with People open
    const peopleUrls = this.props.content.people.map(item => item.name.replace(/\s/g, '-').toLowerCase());

    if (peopleUrls.includes(window.location.pathname.replace('/', ''))) {
      const peopleSection = document.querySelector('section.people');

      if (history && 'scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
      }

      window.scrollTo(0, peopleSection.offsetTop);
    }
  }

  componentWillUnmount() {
    if (ExecutionEnvironment.canUseDOM) {
      const peopleVideos = document.querySelectorAll('section.people article.employee video');

      for (const peopleVideo of peopleVideos) {
        peopleVideo.removeEventListener('mousemove', this.handleHoverVideo);
      }
    }
  }

}

export default connect(mapStateToProps)(People);


// WEBPACK FOOTER //
// ./src/sections/people/people.jsx